<template>
  <div class="user_bar_inner">
    <div v-if="user" class="user">
      <div class="flex">
        <div class="userLogo">
          <el-badge v-if="(permission == 0 || permission == 2) && this.noDoMesNum != 0" :value="this.noDoMesNum"
            :max="99" class="item">
            <img src="../assets/yuan1.jpg" />
          </el-badge>
          <img v-else src="../assets/yuan1.jpg" />
        </div>
        <div class="flex-item">{{ this.user.name }}</div>
        <div class="flex-item" style="margin-left: 20px">
          <el-button @click="openCusDialog" plain>客户</el-button>
        </div>
        <div class="flex-item" style="margin-left: 20px">
          <el-button @click="openToolDialog" plain>工具</el-button>
        </div>
      </div>
      <div class="user_subpanel">
        <div class="user_sub_item">{{ this.user.permissionStr }}</div>
        <div v-if="permission == 0 || permission == 3" class="user_sub_item check" @click="openDialog">
          管理员列表
        </div>
        <div v-if="permission == 0 || permission == 2" class="user_sub_item check" @click="openMessageDialog">
          <el-badge v-if="this.noDoMesNum != 0" :value="this.noDoMesNum" :max="99" class="item">
            待处理留言
          </el-badge>
          <span v-else> 待处理留言</span>
        </div>
        <div class="user_sub_item check" @click="EistLogin">退出登陆</div>
      </div>
      <el-dialog v-model="customerVisible" title="客户列表" width="20%" center>
        <div style="text-align: center">
          <el-button plain style="
              margin-bottom: 20px;
              width: 90%;
              height: 100px;
              font-size: 16px;
              margin-left: 12px;
            " @click="openCustomerDialog">配电与工业自动化元件<br /><br />(含：仪器仪表)</el-button>
          <el-button plain style="margin-bottom: 20px; width: 90%; height: 100px; font-size: 16px"
            @click="openCustomerDialog">机械与机器人集成</el-button>
          <el-button plain style="margin-bottom: 20px; width: 90%; height: 100px; font-size: 16px"
            @click="openCustomerDialog">清洁系统</el-button>
          <el-button plain style="margin-bottom: 20px; width: 90%; height: 100px; font-size: 16px"
            @click="openCustomerDialog">数采模块</el-button>
        </div>
      </el-dialog>
      <el-dialog v-model="cusVisible" title="客户列表" width="65%" center>
        <div><el-button plain @click="addCusDialog">新增</el-button></div>
      </el-dialog>
      <el-dialog v-model="addCusVisible" title="客户" width="60%" center>
        <div>
          <el-form :model="cusfrom" style="display: flex; flex-wrap: wrap" :rules="rules" ref="cusfrom">
            <el-form-item label="名称：" prop="name" label-width="120px">
              <el-input v-model="cusfrom.name" placeholder="请输入名称" style="height: 30px; width: 214px" clearable />
            </el-form-item>
            <el-form-item label="联系人：" prop="contacts" label-width="120px">
              <el-input v-model="cusfrom.contacts" style="height: 30px; width: 214px" clearable />
            </el-form-item>
            <el-form-item label="联系方式：" prop="phone" label-width="120px">
              <el-input v-model="cusfrom.phone" style="height: 30px; width: 214px" clearable></el-input>
            </el-form-item>
            <el-form-item label="所在行业：" prop="industry" label-width="120px">
              <el-input v-model="cusfrom.industry" style="height: 30px; width: 214px" clearable></el-input>
            </el-form-item>
            <el-form-item label="所在地区：" prop="site" label-width="120px">
              <el-cascader :props="this.district" v-model="cusfrom.site" @change="handleSelectCus" placeholder="请选择地区"
                clearable></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" prop="siteDetail" label-width="120px">
              <el-input v-model="cusfrom.siteDetail" style="height: 30px; width: 214px" clearable></el-input>
            </el-form-item>
            <el-form-item label="客户来源：" prop="perm" label-width="120px">
              <el-select v-model="cusfrom.source" placeholder="请选择客户来源" style="height: 30px; width: 214px" clearable>
                <el-option v-for="perm in permList" :key="perm.key" :label="perm.value" :value="perm.key" />
              </el-select>
            </el-form-item>
            <el-form-item label="跟进阶段：" prop="perm" label-width="120px">
              <el-select v-model="cusfrom.source" placeholder="请选择根据阶段" style="height: 30px; width: 214px" clearable>
                <el-option v-for="perm in permList" :key="perm.key" :label="perm.value" :value="perm.key" />
              </el-select>
            </el-form-item>
            <el-form-item label="跟进人员：" prop="perm" label-width="120px">
              <el-select v-model="cusfrom.source" placeholder="请选择跟进人员" style="height: 30px; width: 214px" clearable>
                <el-option v-for="perm in permList" :key="perm.key" :label="perm.value" :value="perm.key" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-tabs v-model="mesStatus" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="跟进记录" name="1">
              <div cless="mes-list"></div>
            </el-tab-pane>
            <el-tab-pane label="附件信息" name="2">
              <div cless="mes-doing-list"></div>
            </el-tab-pane>
            <el-tab-pane label="项目概况" name="3">
              <div style="display: flex; border-radius: 3px; border: 1px solid #efefef">
                <div class="pro">
                  <div class="flex">
                    <div class="pro_title" style="width: 90%">项目概况</div>
                    <div>
                      <el-button v-if="isUp" type="primary" plain @click="openThirdToken()">获取关联凭证</el-button>
                    </div>
                  </div>
                  <el-form :model="projectForm" :rules="rules" ref="projectForm">
                    <el-form-item prop="name" style="width: 217px">
                      <el-input v-if="this.isUp" v-model="projectForm.name" placeholder="请输入项目名称" />
                      <span v-else>{{ this.projectForm.name }}</span>
                    </el-form-item>
                    <el-form-item prop="content">
                      <el-input v-if="this.isUp" v-model="projectForm.content" type="textarea" :rows="5"
                        placeholder="请输入简介" />
                      <span v-else>{{ this.projectForm.content }}</span>
                    </el-form-item>
                    <el-form-item prop="date" style="width: 217px">
                      <el-input v-if="this.isUp" v-model="projectForm.date" placeholder="请输入数据存储期限" />
                      <span v-else>数据存储时长：{{
                        this.projectForm.date
                      }}天<br />存储期满，自动清除旧数据</span>
                    </el-form-item>
                  </el-form>
                  <div style="font-size: 16px; font-weight: 600">
                    组态
                    <div>
                      <el-button v-if="isUp" @click="duURL()" type="primary" plain
                        style="margin-left: 12px">关联组态</el-button>
                      <el-button @click="toURL()" type="primary" plain>进入组态</el-button>
                    </div>
                  </div>
                </div>
                <div class="work">
                  <div class="flex">
                    <div class="pro_title" style="width: 90%">项目车间</div>
                    <div>
                      <el-button v-if="isUp" type="primary" plain @click="openWorkDialog()">关联车间</el-button>
                    </div>
                  </div>
                  <div class="work_des">
                    <div v-if="this.workValue == 1" class="work_hover" @click="work(1)">
                      车间一
                    </div>
                    <div v-if="this.workValue != 1" class="work_cont" @click="work(1)">
                      车间一
                    </div>
                    <div v-if="this.workValue == 2" class="work_hover" @click="work(2)">
                      车间二
                    </div>
                    <div v-if="this.workValue != 2" class="work_cont" @click="work(2)">
                      车间二
                    </div>
                    <div v-if="this.workValue == 3" class="work_hover" @click="work(3)">
                      车间三
                    </div>
                    <div v-if="this.workValue != 3" class="work_cont" @click="work(3)">
                      车间三
                    </div>
                  </div>
                  <div class="work_content">
                    <div style="width: 30%">终端网关：{{ this.workForm.name }}</div>
                    <div style="width: 37%">链接情况：{{ this.workForm.statusStr }}</div>
                    <div>
                      <el-button type="primary" plain style="margin-right: 10px">场景浏览</el-button>
                    </div>
                    <div>
                      <el-button v-if="isUp" type="danger" plain>关闭车间</el-button>
                    </div>
                  </div>
                  <div style="margin-left: 20px; line-height: 30px">
                    车间简介：{{ this.workForm.content }}
                  </div>
                  <div class="flex" style="line-height: 40px">
                    <div class="divice" style="width: 90%">设备</div>
                    <div>
                      <el-button v-if="isUp" type="primary" plain @click="openDeviceDialog()">关联设备</el-button>
                    </div>
                  </div>
                  <el-table :data="this.deviceList" border style="width: 100%" height="250px">
                    <el-table-column prop="name" label="设备名称" width="82">
                    </el-table-column>
                    <el-table-column prop="statusStr" label="设备状态" width="82">
                    </el-table-column>
                    <el-table-column prop="statusingStr" label="运行状态" width="82">
                    </el-table-column>
                    <el-table-column prop="manu" label="厂家" width="100">
                    </el-table-column>
                    <el-table-column prop="model" label="型号" width="100">
                    </el-table-column>
                    <el-table-column prop="installTime" label="安装时间" width="100">
                    </el-table-column>
                    <el-table-column prop="content" label="备注" width="100">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template #header><span>操作</span></template>
                      <template v-slot="scope">
                        <el-button @click="deviceHandleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button @click="devicehandleEdit(scope.$index, scope.row)">预览</el-button>
                        <el-button type="danger" @click="deviceHandleDelete(scope.$index, scope.row)">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" v-if="this.adminTotal != 0">
                    <el-pagination @size-change="deviceHandleSizeChange" @current-change="deviceHandleCurrentChange"
                      background :current-page="this.deviceCurrentPage" :page-sizes="[8, 16, 40, 80]"
                      :page-size="this.devicePageSize" layout="total, sizes, prev, pager, next, jumper"
                      :total="this.deviceTotal" class="full-width">
                    </el-pagination>
                  </div>
                  <el-dialog v-model="thirdVisible" title="获取关联凭证" width="30%" center>
                    <el-form :model="thirdfrom" :rules="rulesThird" ref="thirdfrom" style="width: 90%">
                      <el-form-item label="账号：" prop="userName" label-width="120px" style="height: 40px">
                        <el-input v-model="thirdfrom.userName" placeholder="请输入账号" clearable style="height: 40px" />
                      </el-form-item>
                      <el-form-item label="密码：" prop="password" label-width="120px" style="height: 40px">
                        <el-input placeholder="请输入密码" v-model="thirdfrom.password" show-password clearable
                          style="height: 40px"></el-input>
                      </el-form-item>
                    </el-form>
                    <template #footer>
                      <div class="footer">
                        <span class="dialog-footer">
                          <el-button type="primary" class="login-btn" @click="submitThird('thirdfrom')"
                            style="height: 40px">获取</el-button>
                        </span>
                      </div>
                    </template>
                  </el-dialog>
                  <el-dialog v-model="workVisible" title="关联车间" width="20%" center>
                    <div>
                      <el-button type="primary" plain @click="queryAreaInfo()">选取列表</el-button>
                    </div>
                    <el-form :model="workForm" :rules="rules" ref="workForm">
                      <el-form-item label="车间名称：" prop="name" style="width: 352px">
                        <span>{{ workForm.name }}</span>
                      </el-form-item>
                      <el-form-item label="关联地址：" prop="url" style="width: 352px">
                        <el-input v-model="workForm.url" placeholder="请输入关联URL" />
                      </el-form-item>

                      <el-form-item label="终端网关：" prop="terminal" style="width: 352px">
                        <el-input v-model="workForm.terminal" placeholder="请输入终端网关名称" />
                      </el-form-item>
                      <el-form-item label="链接情况：" prop="status" style="width: 352px">
                      </el-form-item>
                      <el-form-item label="车间简介：" prop="content">
                        <el-input v-model="workForm.content" type="textarea" :rows="5" placeholder="请输入车间简介" />
                      </el-form-item>
                    </el-form>
                    <template #footer>
                      <span class="dialog-footer">
                        <el-button type="primary" @click="submitWork('workForm')" style="height: 30px">关联</el-button>
                      </span>
                    </template>
                  </el-dialog>
                  <el-dialog v-model="areaVisible" title="关联列表" width="20%" center>
                    <el-tree :data="areaData" node-key="id" default-expand-all :expand-on-click-node="false"
                      :render-content="renderContent" @node-click="handleNodeClick">
                    </el-tree>
                  </el-dialog>
                </div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="客户需求" name="2">
              <div cless="mes-doing-list"></div>
            </el-tab-pane> -->
          </el-tabs>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="addCusVisible = false" style="height: 30px">取消</el-button>
            <el-button type="primary" @click="submitAdmin('adminfrom')" style="height: 30px">确认添加</el-button>
          </span>
        </template>
      </el-dialog>
      <el-dialog v-model="toolVisible" title="工具列表" width="20%" center>
        <div style="text-align: center">
          <el-upload :limit="1" :before-upload="beforeUpload" action="file/path" class="upload-demo"
            accept=".xlsx,.xls">
            <div style="
              margin-bottom: 20px;
              width: 300px;
              line-height: 100px;
              font-size: 16px;
              margin-left: 12px;
              border: 1px solid #000;
            ">excel数据摘取整理</div>
          </el-upload>
        </div>
      </el-dialog>
      <el-dialog v-model="excelToolVisible" width="30%" center>
        <div style="text-align: center">
          <el-button plain style="
              margin-bottom: 20px;
              width: 90%;
              height: 50px;
              font-size: 16px;
              margin-left: 12px;
            " @click="doExcel">处理</el-button>
        </div>
      </el-dialog>
      <el-dialog v-model="adminVisible" title="管理员列表" width="40%" center>
        <div class="admin_desc">
          <ul class="admin_query">
            <li class="admin_query_item">
              <span class="demonstration">账号：</span>
              <el-input class="inp" v-model="accout" placeholder="请输入内容" clearable @change="inputChange"></el-input>
            </li>
            <li class="admin_query_item">
              <span class="demonstration">名称：</span>
              <el-input class="inp" v-model="name" placeholder="请输入内容" clearable @change="inputChange"></el-input>
            </li>
            <li class="admin_query_item">
              <span class="demonstration">权限：</span>
              <el-select class="inp" v-model="perm" @change="permissionChange" clearable placeholder="请选择权限">
                <el-option v-for="item in permList" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </li>
          </ul>
        </div>
        <el-table :data="this.adminList" border style="width: 100%" height="442px">
          <el-table-column prop="accout" label="账号" width="165"> </el-table-column>
          <el-table-column prop="name" label="姓名" width="200"> </el-table-column>
          <el-table-column prop="permissionStr" label="权限" width="200">
          </el-table-column>
          <el-table-column label="操作">
            <template #header>
              <span style="padding-right: 35px; padding-left: 10px">操作</span>
              <el-button @click="handleAdd">新增</el-button>
            </template>
            <template v-slot="scope">
              <el-button @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button type="danger" @click="handleDelete(scope.$index, scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="this.adminTotal != 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
            :current-page="this.currentPage" :page-sizes="[8, 16, 40, 80]" :page-size="this.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="this.adminTotal" class="full-width">
          </el-pagination>
        </div>
        <el-dialog v-model="saveVisible" :title="this.title" width="30%" center>
          <el-form :model="adminfrom" :rules="rules" ref="adminfrom">
            <el-form-item label="名称：" prop="name" label-width="120px">
              <el-input v-model="adminfrom.name" placeholder="请输入名称" style="height: 40px" clearable />
            </el-form-item>
            <el-form-item label="账号：" prop="accout" label-width="120px">
              <el-input v-model="adminfrom.accout" placeholder="请输入账号" style="height: 40px" clearable />
            </el-form-item>
            <el-form-item label="密码：" prop="password" label-width="120px">
              <el-input placeholder="请输入密码" v-model="adminfrom.password" :disabled="this.disabled" show-password
                style="height: 40px" clearable></el-input>
            </el-form-item>
            <el-form-item label="权限：" prop="perm" label-width="120px">
              <el-select v-model="adminfrom.perm" placeholder="请选择管理权限" clearable>
                <el-option v-for="perm in permList" style="height: 40px" :key="perm.key" :label="perm.value"
                  :value="perm.key" />
              </el-select>
            </el-form-item>
          </el-form>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="saveVisible = false" style="height: 40px">取消</el-button>
              <el-button type="primary" @click="submitAdmin('adminfrom')" style="height: 40px">确认添加</el-button>
            </span>
          </template>
        </el-dialog>
      </el-dialog>
      <el-dialog v-model="mesVisible" title="留言列表" width="65%" center>
        <div class="mes">
          <div cless="mes-change">
            <div class="mes-selete">
              <el-select class="mes-inp" v-model="type" @change="typeChange" placeholder="请选择留言类型">
                <el-option v-for="item in this.types" :key="item.ty" :label="item.name" :value="item.ty">
                </el-option>
              </el-select>
            </div>
            <el-tabs v-model="mesStatus" type="border-card" @tab-click="handleClick">
              <el-tab-pane label="未处理" name="1">
                <div cless="mes-list">
                  <el-table :data="this.messageList" highlight-current-row border style="width: 100%" height="442px">
                    <el-table-column prop="name" label="留言人名称" width=" 100">
                    </el-table-column>
                    <el-table-column prop="contact" label="联系方式" width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 1" prop="fileName" label="简历" width="480">
                      <template v-slot="scope">
                        <div @click="downfile(scope.row)" style="cursor: pointer">
                          {{ scope.row.fileName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="content" label="咨询内容" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="email" label="邮箱" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="company" label="公司名称" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="site" label="详情地址" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column prop="addtimeStr" label="留言时间" width="110">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="adminStr" label="处理人" width="100">
                    </el-table-column>
                    <el-table-column prop="lastedittimeStr" label="处理时间" width="110">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template #header><span>操作</span></template>
                      <template v-slot="scope">
                        <el-button @click="mesHandleEdit(scope.$index, scope.row)">处理</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" v-if="this.messageTotal != 0">
                    <el-pagination @size-change="mesHandleSizeChange" @current-change="mesHandleCurrentChange"
                      background :current-page="this.mesCurrentPage" :page-sizes="[10, 20, 40, 80]"
                      :page-size="this.mesPageSize" layout="total, sizes, prev, pager, next, jumper"
                      :total="this.messageTotal" class="full-width">
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="permission == 0" label="处理中" name="2">
                <div cless="mes-doing-list">
                  <el-table :data="this.messageList" highlight-current-row border style="width: 100%" height="442px">
                    <el-table-column prop="name" label="留言人名称" width=" 100">
                    </el-table-column>
                    <el-table-column prop="contact" label="联系方式" width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 1" prop="fileName" label="简历" width="480">
                      <template v-slot="scope">
                        <div @click="downfile(scope.row)" style="cursor: pointer">
                          {{ scope.row.fileName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="content" label="咨询内容" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="email" label="邮箱" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="company" label="公司名称" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="site" label="详情地址" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column prop="addtimeStr" label="留言时间" width="110">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="adminStr" label="处理人" width="100">
                    </el-table-column>
                    <el-table-column prop="lastedittimeStr" label="处理时间" width="110">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template #header><span>操作</span></template>
                      <template v-slot="scope">
                        <el-button @click="mesHandleEdit(scope.$index, scope.row)">完成处理</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" v-if="this.messageTotal != 0">
                    <el-pagination @size-change="mesHandleSizeChange" @current-change="mesHandleCurrentChange"
                      background :current-page="this.mesCurrentPage" :page-sizes="[10, 20, 40, 80]"
                      :page-size="this.mesPageSize" layout="total, sizes, prev, pager, next, jumper"
                      :total="this.messageTotal" class="full-width">
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="permission == 0" label="已处理" name="0">
                <div cless="mes-dose-list">
                  <el-table :data="this.messageList" highlight-current-row border style="width: 100%" height="442px">
                    <el-table-column prop="name" label="留言人名称" width=" 100">
                    </el-table-column>
                    <el-table-column prop="contact" label="联系方式" width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 1" prop="fileName" label="简历" width="480">
                      <template v-slot="scope">
                        <div @click="downfile(scope.row)" style="cursor: pointer">
                          {{ scope.row.fileName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="content" label="咨询内容" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="email" label="邮箱" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="company" label="公司名称" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="site" label="详情地址" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column prop="addtimeStr" label="留言时间" width="110">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="adminStr" label="处理人" width="100">
                    </el-table-column>
                    <el-table-column prop="lastedittimeStr" label="处理时间" width="110">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template #header><span>操作</span></template>
                      <template v-slot="scope">
                        <el-button @click="mesHandleEdit(scope.$index, scope.row)">重新处理</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" v-if="this.messageTotal != 0">
                    <el-pagination @size-change="mesHandleSizeChange" @current-change="mesHandleCurrentChange"
                      background :current-page="this.mesCurrentPage" :page-sizes="[10, 20, 40, 80]"
                      :page-size="this.mesPageSize" layout="total, sizes, prev, pager, next, jumper"
                      :total="this.messageTotal" class="full-width">
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="permission == 2" label="我在处理" name="2">
                <div cless="mes-doing-list">
                  <el-table :data="this.messageList" highlight-current-row border style="width: 100%" height="442px">
                    <el-table-column prop="name" label="留言人名称" width=" 100">
                    </el-table-column>
                    <el-table-column prop="contact" label="联系方式" width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 1" prop="fileName" label="简历" width="480">
                      <template v-slot="scope">
                        <div @click="downfile(scope.row)" style="cursor: pointer">
                          {{ scope.row.fileName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="content" label="咨询内容" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="email" label="邮箱" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="company" label="公司名称" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="site" label="详情地址" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column prop="addtimeStr" label="留言时间" width="110">
                    </el-table-column>
                    <el-table-column prop="lastedittimeStr" label="处理时间" width="110">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template #header><span>操作</span></template>
                      <template v-slot="scope">
                        <el-button @click="mesHandleEdit(scope.$index, scope.row)">完成处理</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" v-if="this.messageTotal != 0">
                    <el-pagination @size-change="mesHandleSizeChange" @current-change="mesHandleCurrentChange"
                      background :current-page="this.mesCurrentPage" :page-sizes="[10, 20, 40, 80]"
                      :page-size="this.mesPageSize" layout="total, sizes, prev, pager, next, jumper"
                      :total="this.messageTotal" class="full-width">
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="permission == 2" label="我已处理" name="0">
                <div cless="mes-dose-list">
                  <el-table :data="this.messageList" highlight-current-row border style="width: 100%" height="442px">
                    <el-table-column prop="name" label="留言人名称" width=" 100">
                    </el-table-column>
                    <el-table-column prop="contact" label="联系方式" width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 1" prop="fileName" label="简历" width="480">
                      <template v-slot="scope">
                        <div @click="downfile(scope.row)" style="cursor: pointer">
                          {{ scope.row.fileName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="content" label="咨询内容" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="email" label="邮箱" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="company" label="公司名称" show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column v-if="this.type == 0" prop="site" label="详情地址" show-overflow-tooltip width="120">
                    </el-table-column>
                    <el-table-column prop="addtimeStr" label="留言时间" width="110">
                    </el-table-column>
                    <el-table-column prop="lastedittimeStr" label="处理时间" width="110">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template #header><span>操作</span></template>
                      <template v-slot="scope">
                        <el-button @click="mesHandleEdit(scope.$index, scope.row)">重新处理</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" v-if="this.messageTotal != 0">
                    <el-pagination @size-change="mesHandleSizeChange" @current-change="mesHandleCurrentChange"
                      background :current-page="this.mesCurrentPage" :page-sizes="[10, 20, 40, 80]"
                      :page-size="this.mesPageSize" layout="total, sizes, prev, pager, next, jumper"
                      :total="this.messageTotal" class="full-width">
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-else>
      <el-button @click="login()">登陆</el-button>
      <el-dialog v-model="visible" title="管理员" width="30%" center @keyup.enter="submit('userfrom')">
        <el-form :model="userfrom" :rules="rulesall" ref="userfrom" style="width: 90%">
          <el-form-item label="账号：" prop="accout" label-width="120px" style="height: 40px">
            <el-input v-model="userfrom.accout" placeholder="请输入账号" clearable style="height: 40px" />
          </el-form-item>
          <el-form-item label="密码：" prop="password" label-width="120px" style="height: 40px">
            <el-input placeholder="请输入密码" v-model="userfrom.password" show-password clearable
              style="height: 40px"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="footer">
            <span class="dialog-footer">
              <el-button type="primary" class="login-btn" @click="submit('userfrom')"
                style="height: 40px">登陆</el-button>
            </span>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import axios from "axios";
import CryptoJS from "crypto-js";
import { useStore } from "vuex";

export default {
  data() {
    return {
      adminList: [],
      deviceList: [],
      messageList: [],
      mesDetail: {
        name: "",
        contact: "",
        email: "",
        company: "",
        site: "",
        content: "",
        fileName: "",
        path: "",
      },
      adminfrom: {
        accout: "",
        password: "",
        name: "",
        perm: "",
        status: "",
      },
      cusfrom: {
        name: "",
        contacts: "",
        phone: "",
        industry: "",
        site: "",
        siteDetail: "",
        source: "",
      },
      projectForm: {
        name: "",
        content: "",
        date: "",
      },
      workForm: {
        name: "",
        terminal: "",
        content: "",
        url: "",
        statusStr: "",
        status: "",
      },
      userfrom: {
        accout: "",
        password: "",
      },
      thirdfrom: {
        userName: "",
        password: "",
      },
      types: [
        { name: "咨询信息", ty: 0 },
        { name: "投递信息", ty: 1 },
      ],
      // 获取第三方凭证规则
      rulesThird: {
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      // 表单验证规则
      rulesall: {
        accout: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        perm: [{ required: true, message: "请选择管理权限", trigger: "change" }],
        accout: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      LedPath: "",
      accout: "",
      name: "",
      permList: [],
      visible: false,
      adminVisible: false,
      workVisible: false,
      areaVisible: false,
      customerVisible: false,
      toolVisible: false,
      excelToolVisible: false,
      cusVisible: false,
      addCusVisible: false,
      thirdVisible: false,
      isUp: false,
      store: useStore(),
      user: "",
      permission: "",
      areaData: "",
      disabled: true,
      perm: "",
      pageSize: 8,
      currentPage: 1,
      adminTotal: 0,
      messageTotal: 0,
      mesPageSize: 10,
      mesCurrentPage: 1,
      title: "新增管理员",
      saveVisible: false,
      changeId: "",
      mesVisible: false,
      type: 0,
      mesStatus: "1",
      noDoMesNum: 0,
      workValue: 0,
      isKK: true,
      cuss: [],
      dist: "",
      thirdToken: "",
      file: "",
      district: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          console.log("----", level);
          this.queryCust(node).then((res) => {
            // console.log("-----res", res);
            resolve(res);
          });
        },
      },
    };
  },
  mounted() {
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    this.querypermList();
    this.user = this.store.state.userInfo;
    this.thirdToken = this.store.state.thirdToken;
    this.permission = this.store.state.userInfo
      ? this.store.state.userInfo.permission
      : "";
    if (this.permission && (this.permission == 0 || this.permission == 2)) {
      this.queryMessagePage();
      this.queryNoDomMesTotal();
    }
  },
  methods: {
    renderContent(h, { data }) {
      return data.label;
    },
    openDeviceDialog() {
      axios
        .post(
          "https://preview.nps.iiot.youngsunnb.com/api/third/findDeviceList",
          { token: this.thirdToken },
          {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 0) {
            const aaa = response.data.data.filter(
              (device) => device.area == this.workForm.name
            );
            console.log("re---------", aaa);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取留言列表失败", error);
        });
    },
    handleNodeClick(data) {
      this.workForm.name = data.label;
      axios
        .post(
          "https://preview.nps.iiot.youngsunnb.com/api/third/findAreaInfoById",
          { token: this.thirdToken, id: data.id },
          {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 0) {
            console.log("areaData---------", response.data.data);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取留言列表失败", error);
        });
    },
    openAreaDetail(data) {
      console.log("data----", data);
    },
    login() {
      this.visible = true;
    },
    openThirdToken() {
      if (this.store.state && this.store.state.thirdToken) {
        this.thirdToken = this.store.state.thirdToken;
        return;
      }
      this.thirdVisible = true;
    },
    queryAreaInfo() {
      axios
        .post(
          "https://preview.nps.iiot.youngsunnb.com/api/third/findAllAreaInfo",
          { token: this.thirdToken },
          {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 0) {
            this.areaData = this.toTreeData(response.data.data);
            this.areaVisible = true;
            console.log("areaData---------", this.areaData);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取留言列表失败", error);
        });
    },
    toTreeData(flatData) {
      const idToNodeMap = {};
      const roots = [];
      flatData.forEach((node) => {
        const { areaId } = node;
        const data = {
          id: node.areaId,
          pId: node.pAreaId,
          label: node.areaName,
        };
        if (!idToNodeMap[areaId]) {
          idToNodeMap[areaId] = { ...data, children: [] };
        } else {
          Object.assign(idToNodeMap[areaId], data);
        }
      });
      Object.values(idToNodeMap).forEach((node) => {
        if (node.pId === 0) {
          roots.push(node);
        } else {
          const parent = idToNodeMap[node.pId];
          if (parent) {
            parent.children.push(node);
          }
        }
      });
      return JSON.parse(JSON.stringify(roots));
    },
    duURL() { },
    toURL() {
      window.open(this.LedPath);
    },
    work(value) {
      this.workValue = value;
    },
    EistLogin() {
      const tokenDto = {
        token: this.user.token,
        refreshToken: this.user.refreshToken,
      };
      axios
        .post("/Login/out", tokenDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.user = "";
            this.store.commit("removeUserInfo");
            location.reload();
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取留言列表失败", error);
        });
    },
    queryCust(node) {
      return new Promise((resolve) => {
        axios
          .get("/district/queryByPid", {
            params: { pid: node.value ? node.value : 1 },
          }) // 使用创建的api实例: api.post('/your-endpoint', payload)
          .then((response) => {
            // 处理接口返回的结果
            if (response.data.code === 200) {
              let option = response.data.data.map((item) => {
                return {
                  label: item.district,
                  value: item.id,
                  leaf: item.level > 2,
                };
              });
              // console.log("op------", option);
              resolve(option);
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("地区获取失败，请检查网络或接口地址");
            console.error("地区获取失败", error);
            resolve([]);
          });
      });
    },
    handleSelectCus(value) {
      console.log("------", value);
    },
    openCusDialog() {
      this.customerVisible = true;
    },
    openToolDialog() {
      this.toolVisible = true;
    },
    openCustomerDialog() {
      this.cusVisible = true;
    },
    addCusDialog() {
      this.addCusVisible = true;
      this.isUp = true;
      // this.queryCust(1);
    },
    openDialog() {
      this.adminVisible = true;
      this.queryPage();
    },
    openWorkDialog() {
      this.workVisible = true;
    },
    openMessageDialog() {
      this.mesVisible = true;
      this.queryMessagePage();
    },
    downfile(row) {
      // 提交数据到接口
      axios({
        method: "post",
        url: "/attachment/downLoad",
        params: {
          path: row.path,
          name: row.fileName,
        },
        responseType: "blob",
      })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.data.type });
          const elink = document.createElement("a");
          //创建下载链接
          elink.href = window.URL.createObjectURL(blob);
          //下载后文件名
          elink.download = row.fileName;
          document.body.appendChild(elink);
          //点击下载
          elink.click();
          // 下载完成移除元素
          document.body.removeChild(elink);
          // 释放掉blob对象
          window.URL.revokeObjectURL(elink.href);
          ElMessage.success("下载成功");
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("留言失败", error);
        });
    },
    queryNoDomMesTotal() {
      const messageDto = {
        usCompanyType: this.isKK ? 1 : 2,
      };
      axios
        .post("/message/queryTotal", messageDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.noDoMesNum = response.data.data;
          } else {
            this.noDoMesNum = 0;
            ElMessage.error("请求失败" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    queryMessagePage() {
      const messageDto = {
        isZg: this.permission == 0 ? 1 : 2,
        status: this.mesStatus,
        type: this.type,
        page: this.mesCurrentPage,
        size: this.mesPageSize,
        usCompanyType: this.isKK ? 1 : 2,
      };
      // 提交数据到接口
      axios
        .post("/message/page", messageDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.messageTotal = response.data.data.totalElements;
            this.messageList = response.data.data.content;
          } else {
            this.messageTotal = 0;
            this.messageList = [];
            ElMessage.error("获取留言列表失败" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取留言列表失败", error);
        });
    },
    handleClick(tab) {
      this.mesStatus = tab.props.name;
      this.queryMessagePage();
    },
    handleDisabled() {
      if (this.disabled) {
        this.rules = {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          perm: [{ required: true, message: "请选择管理权限", trigger: "change" }],
          accout: [{ required: true, message: "请输入账号", trigger: "blur" }],
        };
      } else {
        this.rules = {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          perm: [{ required: true, message: "请选择管理权限", trigger: "change" }],
          accout: [{ required: true, message: "请输入账号", trigger: "blur" }],
          password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        };
      }
    },
    handleEdit(index, row) {
      this.title = "管理员编辑";
      this.disabled = !(this.permission == 0);
      this.saveVisible = true;
      this.handleDisabled();
      this.changeId = row.id;
      this.adminfrom.name = row.name;
      this.adminfrom.perm = row.permission;
      this.adminfrom.accout = row.accout;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .get("/admin/delete", {
              params: { Id: row.id },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "移除成功!",
                });
                this.inputChange();
              } else {
                ElMessage.error("移除失败，" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("移除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除",
          });
        });
    },
    permissionChange(value) {
      if (value) {
        this.perm = value;
      } else {
        this.perm = "";
      }
      this.inputChange();
    },
    clentPage() {
      this.pageSize = 8;
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.queryPage();
      }
    },
    handleCurrentChange(val) {
      if (this.currentPage != val) {
        this.currentPage = val;
        this.queryPage();
      }
    },
    queryPage() {
      const adminDto = {
        id: this.user.id,
        name: this.name,
        accout: this.accout,
        permission: this.perm,
        page: this.currentPage,
        size: this.pageSize,
      };
      // 提交数据到接口
      axios
        .post("/admin/page", adminDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.adminTotal = response.data.data.totalElements;
            this.adminList = response.data.data.content;
          } else {
            this.adminTotal = 0;
            this.adminList = [];
            ElMessage.error("获取管理员列表失败" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取管理员列表失败", error);
        });
    },
    querypermList() {
      axios
        .post("/admin/queryPermList") // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.permList = response.data.data;
          } else {
            ElMessage.error("请求失败" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("请求失败：", error);
        });
    },
    inputChange() {
      this.clentPage();
      this.queryPage();
    },
    handleAdd() {
      this.title = "新增管理员";
      this.saveVisible = true;
      this.disabled = false;
      this.handleDisabled();
      this.adminfrom.name = "";
      this.adminfrom.perm = "";
      this.adminfrom.accout = "";
      this.adminfrom.password = "";
      this.changeId = "";
    },
    deleteAdmin() {
      this.saveVisible = false;
      this.inputChange();
    },
    submit(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const pwd = CryptoJS.SHA256(this.userfrom.password).toString();
          // submitToApi();
          const AdminDto = {
            accout: this.userfrom.accout,
            password: pwd,
          };
          // 提交数据到接口
          axios
            .post("/Login/login", AdminDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("登陆成功");
                this.store.commit("setUserInfo", response.data.data);
                this.user = response.data.data;
                this.permission = this.user.permission;
                this.visible = false;
                location.reload();
              } else {
                ElMessage.error("登陆失败：" + response.data.data);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("登陆失败：", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    submitThird(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("userName", this.thirdfrom.userName);
          formData.append("password", this.thirdfrom.password);
          axios
            .post(
              "https://preview.nps.iiot.youngsunnb.com/api/third/findAccessToken",
              formData,
              {
                Headers: {
                  "Content-Type": "x-wwww-form-urlencoded",
                },
              }
            )
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 0) {
                this.thirdToken = response.data.data.token;
                this.store.commit("setThirdToken", response.data.data.token);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("获取留言列表失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    submitWork(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          console.log("关联");
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    submitAdmin(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const str = this.permList.filter((item) => item.key == this.adminfrom.perm)[0]
            .value;
          const pwd = CryptoJS.SHA256(this.adminfrom.password).toString();
          // submitToApi();
          const AdminDto = {
            id: this.changeId,
            accout: this.adminfrom.accout,
            password: pwd,
            permission: this.adminfrom.perm,
            name: this.adminfrom.name,
            status: this.adminfrom.status,
            permissionStr: str,
          };
          // 提交数据到接口
          axios
            .post("/admin/add", AdminDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("添加成功");
                this.saveVisible = false;
                this.inputChange();
              } else {
                ElMessage.error("添加失败：" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("添加失败：", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    typeChange(value) {
      this.type = value;
      this.queryMessagePage();
    },
    mesHandleEdit(index, row) {
      const str =
        row.status == 1
          ? "此操作将认领该留言进行处理，是否继续？"
          : row.status == 2
            ? "确认已完成处理？"
            : "确定重新处理完成？";
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const messageDto = {
            id: row.id,
            status: row.status == 1 ? 2 : 0,
            usCompanyType: this.isKK ? 1 : 2,
          };
          // 提交数据到接口
          axios
            .post("/message/updateStatus", messageDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                if (row.status == 1) {
                  this.queryNoDomMesTotal();
                }
                this.queryMessagePage();
                this.$message({
                  type: "success",
                  message: row.status == 1 ? "成功认领！" : "完成处理！",
                });
              } else {
                ElMessage.error("失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: row.status == 1 ? "已放弃认领！" : "已取消处理！",
          });
        });
    },
    mesHandleSizeChange(val) {
      if (this.mesPageSize != val) {
        this.mesPageSize = val;
        this.queryMessagePage();
      }
    },
    mesHandleCurrentChange(val) {
      if (this.mesCurrentPage != val) {
        this.mesCurrentPage = val;
        this.queryMessagePage();
      }
    },
    clentMesPage() {
      this.mesCurrentPage = 1;
      this.mesPageSize = 10;
    },
    beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      // 校验文件格式
      const isExcel = file.type.includes("excel") || file.name.endsWith(".xlsx") || file.name.endsWith(".xls");
      if (!isExcel) {
        ElMessage.error("仅支持Excel格式文件");
        return false;
      }
      this.file = file;
      this.excelToolVisible = true;
      return false;
    },
    doExcel() {
      const formData = new FormData();
      formData.append("file", this.file);
      // 提交数据到接口
      axios
        .post("/tool/doExcel", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          console.log(response.data);
          const blob = new Blob([response.data], { type: response.data.type });
          const elink = document.createElement("a");
          //创建下载链接
          elink.href = window.URL.createObjectURL(blob);
          //下载后文件名
          elink.download = this.file.name;
          document.body.appendChild(elink);
          //点击下载
          elink.click();
          // 下载完成移除元素
          document.body.removeChild(elink);
          // 释放掉blob对象
          window.URL.revokeObjectURL(elink.href);
          ElMessage.success("下载成功");

        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("excel文件处理失败", error);
        });
    }
  },
};
</script>
<style>
.user_bar_inner {
  position: relative;
  margin-left: 50px;
}

.footer {
  text-align: center;
}

.login-btn {
  width: 50%;
}

.userLogo {
  padding-top: 5px;
  width: 50px;
  height: 56px;
  padding-right: 10px;
}

.userLogo img {
  width: 100%;
  border-radius: 50%;
}

.user {
  font-size: 16px;
  display: inline-block;
  text-align: center;
  color: #222;
  text-decoration: none;
  position: relative;
}

.user_subpanel {
  position: absolute;
  width: 100%;
  left: 0px;
  z-index: 100;
  display: none;
}

.user_subpanel .user_sub_item {
  background: #fff;
  width: 100%;
  align-items: center;
  height: 50px;
  line-height: 50px;
}

.check {
  cursor: pointer;
}

.user:hover .user_subpanel {
  display: block;
}

.check:hover {
  background: #4352da;
  color: #ebebeb;
}

.check:active {
  background: #4352da;
  color: #ebebeb;
}

.admin_query {
  list-style: none;
}

.admin_query .admin_query_item {
  display: inline-block;
  width: 33%;
  font-size: 16px;
  text-align: center;
  color: #999898;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}

.admin_query .inp {
  width: 160px;
}

.pro {
  width: 20%;
  padding-left: 10px;
  padding-right: 10px;
}

.work {
  width: 76%;
  background: #fdfdfd;
  border-radius: 3px;
  border: 1px solid #efefef;
  padding-left: 10px;
  padding-right: 10px;
}

.pro_title {
  font-size: 18px;
  font-weight: 600;
}

.divice {
  font-size: 16px;
  font-weight: 600;
}

.work_des {
  display: flex;
  flex-wrap: wrap;
  background: #e3e3e3;
  /* height: 40px; */
  line-height: 40px;
  font-size: 15px;
  font-weight: 600;
}

.work_content {
  display: flex;
  padding-left: 20px;
  line-height: 40px;
}

.work_cont {
  padding-right: 10px;
  padding-left: 10px;
  cursor: pointer;
}

.work_cont:hover {
  font-size: 16px;
  background: #d8d8d8;
}

.work_hover {
  background: #3799ff;
  color: #fff;
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 5px;
  margin-top: 1px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
